const PRICING_METHOD_HEADER = 'Pricing Method';
const FIRST_ADDITIONAL_PRICING_METHOD = 'Rate Table Lookup+Incremental Rating';
const SUPPORTS_INCREMENTAL_PRICING_METHODS = [
  'Rate Table Lookup',
  'Direct Rate Calculation',
  'Incremental Rating',
];
const SUPPORTS_INCREMENTAL_DIRECT_MU = 1;
const FIRST_ADDITIONAL_WEIGHT = 2;

function normalizeCell(value) {
  return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
}

function normalizePricingMethod(value) {
  return normalizeCell(value).replace(/\s*\+\s*/g, '+');
}

function getPricingMethodColumnIndex(headerRow) {
  return (headerRow || []).findIndex(cell => normalizeCell(cell) === normalizeCell(PRICING_METHOD_HEADER));
}

function detectImportTypeFromPricingMethod(firstSheetRows) {
  const rows = firstSheetRows || [];
  const headerRow = rows[0] || [];
  const pricingMethodIndex = getPricingMethodColumnIndex(headerRow);
  if (pricingMethodIndex < 0) return null;

  const pricingMethods = rows.slice(1)
    .map(row => normalizePricingMethod(row && row[pricingMethodIndex]))
    .filter(Boolean);
  if (!pricingMethods.length) return null;

  const firstAdditionalPricingMethod = normalizePricingMethod(FIRST_ADDITIONAL_PRICING_METHOD);
  const supportsIncrementalPricingMethods = SUPPORTS_INCREMENTAL_PRICING_METHODS.map(normalizePricingMethod);
  const matchesFirstAdditionalWeight = pricingMethods.every(
    method => method === firstAdditionalPricingMethod
  );
  const matchesSupportsIncrementalDirectMu = pricingMethods.every(
    method => supportsIncrementalPricingMethods.includes(method)
  );

  if (matchesFirstAdditionalWeight) return FIRST_ADDITIONAL_WEIGHT;
  if (matchesSupportsIncrementalDirectMu) return SUPPORTS_INCREMENTAL_DIRECT_MU;
  return null;
}

function isSelectedImportTypeMatched(detectedType, selectedType) {
  return detectedType !== null && Number(detectedType) === Number(selectedType);
}

function isDetectedImportTypeSupported(detectedType) {
  return [SUPPORTS_INCREMENTAL_DIRECT_MU, FIRST_ADDITIONAL_WEIGHT].includes(Number(detectedType));
}

module.exports = {
  detectImportTypeFromPricingMethod,
  isDetectedImportTypeSupported,
  isSelectedImportTypeMatched
};
